import { X } from "lucide-react";
import type { ProductInfoCreative } from "@/feature/ads/mock/productsInfoCreative.mock";
import { dictionary, Language } from "@/utils/dictionary";

interface AdStudioHeaderProps {
  product: ProductInfoCreative;
  onClose: () => void;
  language: Language;
}

export function AdStudioHeader({ product, onClose, language }: AdStudioHeaderProps) {
  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-border flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-background border border-border overflow-hidden flex-shrink-0">
          <img
            src={product.image_url}
            alt={product.name}
            className="w-full h-full object-contain p-0.5"
          />
        </div>
        <div>
          <h2 className="text-base font-semibold text-foreground leading-tight">{dictionary["ad-studio"]?.[language as Language] || "Ad Studio"}</h2>
          <p className="text-sm text-muted-foreground leading-tight truncate max-w-[200px]">{product.name}</p>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={onClose}
          className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
          aria-label={dictionary["close"]?.[language as Language] || "Close"}
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
